import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div`
  background: rgb(255, 255, 255);
  overflow: hidden;
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 12px 32px;
  position: relative;  
`;

const ImageContainer = styled.div`
  padding: 0px;
  border-radius: 0px 0px 0px 32px;
`;

const ImageWrapper = styled.img`
  width: 100%;
  height: 164px;
  border-radius: 0px 32px;
  object-fit: cover;
`;

const ImageOverlay = styled.div`
  position: absolute;
  height: 164px;
  left: 0px;
  right: 0px;
  top: 0px;
  background: linear-gradient(
    rgba(94, 81, 77, 0) 0%,
    rgba(94, 81, 77, 0.74) 100%
  );
  border-radius: 0px 0px 0px 32px;
`;

const BgContainer = styled.div`
  position: absolute;
  right: 0px;
`;

const CardContainer = styled.div`
  position: absolute;
  height: 98px;
  left: calc(50% - 78px);
  top: calc((50% - 49px) - 30px);
  width: 156px;
`;

const CardImage = styled.img`
  padding: 0px;
  width: 156px;
  object-fit: cover;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: rgb(133, 113, 77);
  min-height: 60px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const Description = styled.div`
  min-height: 60px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgb(94, 81, 77);
  display: -webkit-box;
  overflow: hidden;
  text-align: justify;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media screen and (max-width: 767px) {
    min-height: initial; 
  }
`;
const Button = styled.a`
  border-radius: 0.5em !important;
  width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  height: 38px;
`;

const LandingCardBox = function (props) {
  const { t } = useTranslation();
  return (
    <Container className='mb-4'>
      <ImageContainer className='m-0'>
        <ImageWrapper alt={props.title} src={props.image} />
        <ImageOverlay />
      </ImageContainer>
      <BgContainer>
        <svg
          width='180'
          height='127'
          viewBox='0 0 180 127'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_3901_494)'>
            <rect
              width='172.904'
              height='172.904'
              rx='12'
              transform='matrix(0.693828 -0.720141 0.693828 0.720141 96 37.5151)'
              fill='#F2A900'
              fillOpacity='0.05'
            ></rect>
            <rect
              width='172.904'
              height='172.904'
              rx='12'
              transform='matrix(0.693828 -0.720141 0.693828 0.720141 0 3.51514)'
              fill='#F2A900'
              fillOpacity='0.05'
            ></rect>
          </g>
          <defs>
            <clipPath id='clip0_3901_494'>
              <rect width='188' height='127' fill='white'></rect>
            </clipPath>
          </defs>
        </svg>
      </BgContainer>
      <CardContainer>
        {props.cardImage && (
          <CardContainer>
            <CardImage alt={props.title} src={props.cardImage} />
          </CardContainer>
        )}
      </CardContainer>
      <div className='px-4 m-0 row'>
        <Title className='mt-5 mb-2'>{props.title}</Title>
        {props.description && (
          <Description className='mt-1 mb-3'>{props.description}</Description>
        )}
        <div className='d-grid mb-4'>
          <Button
            href={props.redirectUrl}
            className='btn btn-outline-primary d-inline-block'
          >
            {t('LihatSelengkapnya')}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default LandingCardBox;
